import React, { useState } from "react";
// Custom Components
import VerticalPolaroidImage from "./VerticalPolaroidImage";
import HorizontalPolaroidImage from "./HorizontalPolaroidImage";
import ImageViewerModal from "../image-viewer/ImageViewerModal";
// Images
import { getHorizontalImageList, getVerticalImageList } from "../../utils/data";
// Styles
import "./polaroid-carousel.css";

function PolaroidCarousel() {
  const verticalPolaroidImages = getVerticalImageList();
  const horizontalPolaroidImages = getHorizontalImageList();

  const [activeIndex, setActiveIndex] = useState(2);
  const [modalImage, setModalImage] = useState(null);

  const handlePlaroidClick = (index) => {
    setActiveIndex(index);
  };

  const openImageViewerModal = (image) => {
    setModalImage(image);
  };

  const closeImageViewerModal = () => {
    setModalImage(null);
  };

  return (
    <>
      <section className="polaroidCarousel">
        {verticalPolaroidImages.map((it, i) => {
          const zIndex = activeIndex === i ? 3 : 2 - Math.abs(activeIndex - i);

          return (
            <VerticalPolaroidImage
              key={it.id}
              image={it.src}
              caption={it.caption}
              style={{
                zIndex: zIndex,
                transform:
                  activeIndex === it.id ? "scale(1.2) translateY(-10px)" : "",
              }}
              onClick={() => {
                handlePlaroidClick(it.id);
                openImageViewerModal(it);
              }}
            />
          );
        })}
      </section>

      <section className="polaroidCarousel">
        {horizontalPolaroidImages.map((it, i) => {
          const zIndex = activeIndex === i ? 3 : 2 - Math.abs(activeIndex - i);

          return (
            <HorizontalPolaroidImage
              key={it.id}
              image={it.src}
              caption={it.caption}
              style={{
                zIndex: zIndex,
                transform:
                  activeIndex === i ? "scale(1.2) translateY(-10px)" : "",
              }}
              onClick={() => {
                handlePlaroidClick(i);
                openImageViewerModal(it);
              }}
            />
          );
        })}

        {modalImage && (
          <ImageViewerModal
            isVisible={!!modalImage}
            modalImage={modalImage}
            closeModal={closeImageViewerModal}
          />
        )}
      </section>
    </>
  );
}

export default PolaroidCarousel;
